import { ActionTree } from 'vuex';

import { RootState } from '@/store/types';

import { subscribableStore } from './common';
import { SharedActivitiesState } from './types';

const actions: ActionTree<SharedActivitiesState, RootState> = {
  ...subscribableStore.actions,
};

export default actions;
